export default __webpack_public_path__ + "static/media/019-boutique.bb3522b9.svg";